(() => {
  const configElement = document.getElementById('HusarCartDispatchConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const managedKey = '_husar_dispatch_managed';
  const originalKey = '_husar_original_dispatch';
  let running = null;
  let requested = false;
  const permittedForms = new WeakSet();
  const pendingForms = new WeakSet();

  function nextChange(cart) {
    const hasHusar = cart.items.some(item => (item.sku || '').startsWith('HPA-HUS-'));
    for (const item of cart.items) {
      const previous = item.properties || {};
      const properties = { ...previous };
      if (hasHusar && (Object.hasOwn(previous, 'Dispatch') || (item.sku || '').startsWith('HPA-HUS-'))) {
        if (previous[managedKey] !== '1') {
          properties[originalKey] = previous.Dispatch || '';
          properties[managedKey] = '1';
        }
        properties.Dispatch = config.dispatch;
      } else if (!hasHusar && previous[managedKey] === '1') {
        if (previous[originalKey]) properties.Dispatch = previous[originalKey];
        else delete properties.Dispatch;
        delete properties[managedKey];
        delete properties[originalKey];
      }
      if (JSON.stringify(properties) !== JSON.stringify(previous)) return { id: item.key, quantity: item.quantity, properties };
    }
    return null;
  }

  async function jsonRequest(path, options = {}) {
    const response = await fetch(config.root + path, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Cart dispatch update failed');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
    return cart;
  }

  function showError() {
    const target = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (target) target.textContent = config.error;
  }

  function sync() {
    requested = true;
    if (running) return running;
    running = (async () => {
      let cart;
      let changed = false;
      do {
        requested = false;
        cart = await jsonRequest('cart.js');
        const limit = cart.items.length * 2 + 2;
        let count = 0;
        let change;
        while ((change = nextChange(cart))) {
          if (++count > limit) throw new Error('Cart changed during dispatch update');
          cart = await jsonRequest('cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(change)
          });
          changed = true;
        }
      } while (requested);
      if (changed && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'husar-dispatch', cartData: cart });
      }
      return cart;
    })().finally(() => { running = null; });
    return running;
  }

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source !== 'husar-dispatch') sync().catch(showError);
    });
  }

  document.addEventListener('submit', async event => {
    const form = event.target;
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout' || !form.matches('form[action*="/cart"]')) return;
    if (permittedForms.has(form)) {
      permittedForms.delete(form);
      return;
    }
    event.preventDefault();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    try {
      await sync();
      const currentForm = form.isConnected ? form : document.getElementById(form.id);
      const currentButton = submitter.isConnected ? submitter : document.querySelector('[name="checkout"]');
      if (!currentForm || !currentButton || currentButton.disabled) return;
      permittedForms.add(currentForm);
      currentForm.requestSubmit(currentButton);
    } catch {
      showError();
    } finally {
      pendingForms.delete(form);
    }
  }, true);

  if (config.initialSync) sync().catch(showError);
})();
